namespace TabAurous.OMS {
    export interface AttributeMasterRow {
        AttributeId?: number;
        AttributeTypeId?: number;
        AttributeCode?: string;
        AttributeName?: string;
        StdPurity?: number;
        MinPurity?: number;
        MaxPurity?: number;
        GroupSieveId?: number;
        IsParent?: boolean;
        SPGravity?: number;
        PurchaseFormula?: number;
        SalesFormula?: number;
        FixedName?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace AttributeMasterRow {
        export const idProperty = 'AttributeId';
        export const nameProperty = 'AttributeCode';
        export const localTextPrefix = 'OMS.AttributeMaster';
        export const lookupKey = 'OMS.AttributeMaster';

        export function getLookup(): Q.Lookup<AttributeMasterRow> {
            return Q.getLookup<AttributeMasterRow>('OMS.AttributeMaster');
        }
        export const deletePermission = 'Product:Attribute:Delete';
        export const insertPermission = 'Product:Attribute:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:Attribute:Edit';

        export declare const enum Fields {
            AttributeId = "AttributeId",
            AttributeTypeId = "AttributeTypeId",
            AttributeCode = "AttributeCode",
            AttributeName = "AttributeName",
            StdPurity = "StdPurity",
            MinPurity = "MinPurity",
            MaxPurity = "MaxPurity",
            GroupSieveId = "GroupSieveId",
            IsParent = "IsParent",
            SPGravity = "SPGravity",
            PurchaseFormula = "PurchaseFormula",
            SalesFormula = "SalesFormula",
            FixedName = "FixedName",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
